const helpCenterEvent = {
  ADD_HELP_CENTER: 'ADD_HELP_CENTER',
  EDIT_HELP_CENTER: 'EDIT_HELP_CENTER',
  DEL_HELP_CENTER: 'DEL_HELP_CENTER'
};

export default helpCenterEvent;